import React from 'react';
import styles from './FormInput.module.scss';

const FormInput = (props) => { 
    const { 
        label, 
        placeholder, 
        customStyle, 
        customInputStyle, 
        type, 
        onChange,
        onClear,
        clearLabel, 
        value, 
        error, 
        valid, 
        touched,
        disabled, 
        rows, 
        cols 
    } = props;
    let inputStyles = [styles.InputBox];
    if(error && touched){
        inputStyles.push(styles.ErrorItem);
    }
    if(valid){
        inputStyles.push(styles.ValidItem);    
    }
    return(
        <div className={styles.FormInput} style={customStyle ? customStyle : null}>
            {label &&
                <label className={styles.Label}>
                    {label}
                </label>
            }
            <div style={{width:'100%', display:'flex', justifyContent:'flex-end', alignItems: type==='textarea'? "flex-end": "center"}}>
            { onClear && value && type!=='textarea' &&
            <i onClick={onClear} className={`fa fa-times ${styles.ClearIconText}`} />
            }
            { onClear && value && type==='textarea' &&
            <p onClick={onClear} className={styles.ClearTextLabel}>{clearLabel}</p>
            }
            { type==='textarea' && 
                <textarea 
                    className={inputStyles.join(' ')}  
                    placeholder={placeholder}
                    value={value ? value : ""} 
                    onChange={onChange}
                    style={customInputStyle? customInputStyle : null}
                    rows={rows ? rows : 2}
                    cols={cols? cols : 26 }
                    disabled={disabled ? disabled : false}
                >
                </textarea>
            }
            { (type==='text'|| type==='password') &&
                <input
                    className={inputStyles.join(' ')} 
                    placeholder={placeholder}
                    onChange={onChange}
                    value={value ? value : ""} 
                    type={type}
                    style={customInputStyle ? customInputStyle : null}
                    disabled={disabled ? disabled : false}
                />
            }
            </div>
            { (error && touched) &&
            <div className={styles.Error}>
            {error}
            </div>
            }
        </div>
    )
}

export default FormInput;